module.exports = __webpack_public_path__ + "img/superu.a1deed49.jpg";